'use strict';

var utils = require('@liquorice/utils');
var isFragment = require('./isFragment.js');
var fragmentMasking = require('./types/fragment-masking.js');

function getMaybeFragmentData(fragment, maybeFragmentData) {
    if (maybeFragmentData === null || maybeFragmentData === undefined) {
        return null;
    }
    if (Array.isArray(maybeFragmentData)) {
        return utils.makeNonNullableArray(maybeFragmentData.map((data)=>getMaybeFragmentData(fragment, data)));
    }
    if (isFragment(maybeFragmentData)) return fragmentMasking.getFragmentData(fragment, maybeFragmentData);
    const data = maybeFragmentData;
    return data;
}

module.exports = getMaybeFragmentData;
